import React from "react";

function fmtGaugeNum(v, dp = 2) {
    const n = parseFloat(v);
    if (!Number.isFinite(n)) return "—";
    return n.toFixed(dp);
}

/** SVG arc gauge — same visual as Cross Margin Account page. */
export default function CrossMarginLevelGauge({ level, mmr = 1.1, warningRate = 1.15 }) {
    const isNum = Number.isFinite(level);
    const MIN = 1.0;
    const MAX = 3.0;
    const pct = isNum ? Math.min(1, Math.max(0, (level - MIN) / (MAX - MIN))) : 0;

    const cx = 56;
    const cy = 56;
    const r = 44;
    const strokeW = 8;
    const startAngle = 210;
    const sweep = 120;
    const toRad = (deg) => (deg * Math.PI) / 180;
    const arcPt = (deg) => ({
        x: cx + r * Math.cos(toRad(deg)),
        y: cy + r * Math.sin(toRad(deg)),
    });
    const describeArc = (startDeg, endDeg) => {
        const s = arcPt(startDeg);
        const e = arcPt(endDeg);
        const large = Math.abs(endDeg - startDeg) > 180 ? 1 : 0;
        return `M ${s.x} ${s.y} A ${r} ${r} 0 ${large} 1 ${e.x} ${e.y}`;
    };

    const endAngle = startAngle + sweep * pct;
    const color = !isNum
        ? "#6b7280"
        : level < mmr
            ? "#e45561"
            : level < warningRate
                ? "#f59e0b"
                : "#01bc8d";

    return (
        <svg width={112} height={80} viewBox="0 0 112 80" aria-label={`Margin level ${isNum ? level : "—"}`}>
            <path d={describeArc(startAngle, startAngle + sweep)} fill="none" stroke="#e5e7eb" strokeWidth={strokeW} strokeLinecap="round" />
            {isNum && pct > 0 && (
                <path d={describeArc(startAngle, endAngle)} fill="none" stroke={color} strokeWidth={strokeW} strokeLinecap="round" />
            )}
            {isNum && (
                <circle cx={arcPt(endAngle).x} cy={arcPt(endAngle).y} r={strokeW / 2 + 1} fill={color} />
            )}
            <text x={cx} y={cy + 10} textAnchor="middle" fontSize={18} fontWeight={700} fill={color}>
                {isNum ? fmtGaugeNum(level) : "—"}
            </text>
        </svg>
    );
}
